import { Link } from 'react-router-dom';
import SiteLayout from '@/components/feature/SiteLayout';
import Seo from '@/components/feature/Seo';
import Breadcrumbs from '@/components/feature/Breadcrumbs';
import ContactForm from './components/ContactForm';
import { siteInfo } from '@/mocks/site';

export default function ContactPage() {
  const jsonLd = [
    {
      '@context': 'https://schema.org',
      '@type': 'ContactPage',
      name: '联系我们｜深夜爆料',
      description:
        '通过表单提交线索、更正、授权或合作需求，深夜爆料编辑组通常在 48 小时内回复。',
      inLanguage: 'zh-CN',
    },
    {
      '@context': 'https://schema.org',
      '@type': 'Organization',
      name: '深夜爆料',
      email: siteInfo.email,
      contactPoint: [
        {
          '@type': 'ContactPoint',
          contactType: '投稿与线索',
          email: siteInfo.submitEmail,
          availableLanguage: 'zh-CN',
        },
      ],
    },
    {
      '@context': 'https://schema.org',
      '@type': 'BreadcrumbList',
      itemListElement: [
        { '@type': 'ListItem', position: 1, name: '首页', item: '/' },
        { '@type': 'ListItem', position: 2, name: '联系我们', item: '/contact' },
      ],
    },
  ];

  return (
    <SiteLayout>
      <Seo
        title="联系我们｜深夜爆料 投稿与商务合作入口"
        description="向深夜爆料提交线索、内容更正、授权转载或商务合作需求。支持匿名投稿，编辑在线时段为每日 21:00 至次日 04:00，通常在 48 小时内回复。"
        keywords="深夜爆料投稿,深夜爆料联系,深夜爆料商务合作,深夜爆料更正,新瓜速递"
        path="/contact"
        ogType="website"
        jsonLd={jsonLd}
      />

      <div className="mx-auto w-full px-4 py-8 md:px-10 md:py-12">
        <Breadcrumbs items={[{ label: '联系我们' }]} />

        <header className="mb-10 max-w-3xl">
          <span className="text-xs tracking-[0.24em] text-primary-400">CONTACT</span>
          <h1 className="mt-4 font-heading text-3xl font-black leading-tight text-foreground-50 md:text-4xl">
            投稿、更正、合作，都从这里开始
          </h1>
          <p className="mt-4 text-sm leading-relaxed text-foreground-400 md:text-base">
            无论是一条还没被讲出来的线索，还是一处需要更正的细节，都可以用下面这张表单提交。我们默认匿名处理投稿人信息，进入核实流程的线索会在 48 小时内收到回复。
          </p>
        </header>

        <div className="grid grid-cols-1 gap-10 lg:grid-cols-[1.6fr_1fr] lg:gap-14">
          <section className="rounded-lg border border-background-200 bg-background-100 p-5 md:p-8">
            <h2 className="mb-6 font-heading text-xl font-bold text-foreground-50">提交信息</h2>
            <ContactForm />
          </section>

          <aside className="space-y-4">
            <div className="rounded-lg border border-background-200 bg-background-100 p-5">
              <h2 className="flex items-center gap-2 font-heading text-base font-semibold text-foreground-100">
                <i className="ri-mail-line text-primary-400"></i>
                联系方式
              </h2>
              <dl className="mt-4 space-y-4 text-sm">
                <div>
                  <dt className="text-xs text-foreground-600">线索与更正</dt>
                  <dd className="mt-1 break-all text-foreground-200">{siteInfo.email}</dd>
                </div>
                <div>
                  <dt className="text-xs text-foreground-600">投稿专用邮箱</dt>
                  <dd className="mt-1 break-all text-foreground-200">{siteInfo.submitEmail}</dd>
                </div>
                <div>
                  <dt className="text-xs text-foreground-600">编辑在线时段</dt>
                  <dd className="mt-1 text-foreground-200">{siteInfo.contactHours}</dd>
                </div>
              </dl>
            </div>

            <div className="rounded-lg border border-secondary-500/25 bg-secondary-500/5 p-5">
              <h2 className="flex items-center gap-2 font-heading text-base font-semibold text-secondary-200">
                <i className="ri-lock-2-line"></i>
                投稿须知
              </h2>
              <ul className="mt-4 space-y-2.5 text-sm leading-relaxed text-foreground-400">
                <li className="flex gap-2">
                  <i className="ri-check-line mt-1 text-secondary-400"></i>
                  默认匿名处理，不对外披露线索人身份
                </li>
                <li className="flex gap-2">
                  <i className="ri-check-line mt-1 text-secondary-400"></i>
                  涉及隐私的截图请先自行打码
                </li>
                <li className="flex gap-2">
                  <i className="ri-check-line mt-1 text-secondary-400"></i>
                  请尽量提供可交叉验证的时间与地点
                </li>
                <li className="flex gap-2">
                  <i className="ri-check-line mt-1 text-secondary-400"></i>
                  与公共利益无关的私人信息不予采用
                </li>
              </ul>
            </div>

            <div className="rounded-lg border border-background-200 bg-background-100 p-5">
              <h2 className="font-heading text-base font-semibold text-foreground-100">
                提交前可以先看
              </h2>
              <div className="mt-4 flex flex-wrap gap-2">
                <Link
                  to="/faq"
                  className="rounded-full bg-background-200 px-3 py-1.5 text-xs text-foreground-300 transition-colors hover:bg-background-300"
                >
                  投稿常见问题
                </Link>
                <Link
                  to="/about"
                  className="rounded-full bg-background-200 px-3 py-1.5 text-xs text-foreground-300 transition-colors hover:bg-background-300"
                >
                  内容原则
                </Link>
                <Link
                  to="/"
                  className="rounded-full bg-primary-500/15 px-3 py-1.5 text-xs text-primary-300 transition-colors hover:bg-primary-500/25"
                >
                  回首页看爆料流
                </Link>
              </div>
            </div>
          </aside>
        </div>
      </div>
    </SiteLayout>
  );
}